const defaultSettings = {
    animationAttibute: 'data-aos',
    reverseAttribute: 'data-aos-reverse',
    thresholdAttribute: 'data-aos-threshold',
};
class AOS {
    constructor(settings = defaultSettings) {
        this.defaultOptions = {
            threshold: 0.6,
            rootMargin: '-30px 0px',
        };
        this.createObserver = (elements, options) => {
            const observer = new IntersectionObserver(entries => this.handleEntries(entries), options);
            elements.forEach(element => observer.observe(element));
        };
        /* handle entries run when a new element is observed (comes into view) */
        this.handleEntries = (entries) => {
            entries.forEach(entry => {
                const cssClass = entry.target.getAttribute(this.settings.animationAttibute);
                const reverse = entry.target.getAttribute(this.settings.reverseAttribute) !== null;
                if (!entry.isIntersecting) {
                    if (reverse) {
                        entry.target.classList.remove(cssClass);
                    }
                    return;
                }
                entry.target.classList.add(cssClass);
            });
        };
        this.settings = settings;
        const elements = document.querySelectorAll(`[${this.settings.animationAttibute}]`);
        if (elements.length === 0) {
            return;
        }
        // Gets a set of grouped elements using the anim-thresholds (threshold for intersection observer)
        const groupedElements = groupBy(Array.from(elements), element => element.getAttribute(this.settings.thresholdAttribute));
        groupedElements.forEach((value, key) => {
            const options = { ...this.defaultOptions };
            const threshold = parseFloat(key);
            if (!isNaN(threshold) && threshold < 1.0) {
                options.threshold = threshold;
            }
            this.createObserver(value, options);
        });
    }
}
// Groups the given array using the expression
function groupBy(array, expression) {
    const map = new Map();
    array.forEach(item => {
        const key = expression(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        }
        else {
            collection.push(item);
        }
    });
    return map;
}
export default AOS;
